<div class="main_content">
    <app-breadcrumb></app-breadcrumb>
    <div class="page_main_sec">
        <div class="row cart-section">
            <div class="col-lg-3">
                <mat-form-field appearance="legacy" [style.width.%]="100">
                    <mat-label for="select_work_item_type">Select Work Item Type</mat-label>
                    <mat-select (selectionChange)="onChangeDoctype($event.value)" [(ngModel)]="selectedDocumentType"
                        id="select_work_item_type">
                        <mat-option [value]="doc" *ngFor="let doc of docTypeList">
                            {{doc.docTypeName}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-lg-2" (click)="downloadExcelTemplate()">
                <span class="download-template-wrp">
                    <span><i class="material-icons">file_download</i></span> Download Template
                </span>
            </div>
            <div class="col-lg-5">
                <div class="progress-sec">
                    <ol class="progress-meter">
                        <li class="progress-point todo" [class.active]="selectedExcelFile!=browseMessage">Upload Excel
                        </li>
                        <li class="progress-point todo" [class.active]="selectedInvoiceFiles!=browseMessage">Upload
                            Invoice</li>
                        <li class="progress-point todo" [class.active]="selectedSupportingFiles!=browseMessage">Upload
                            SD</li>
                        <li class="progress-point todo" [class.active]="isValidated">Validate Invoice</li>
                    </ol>
                </div>
            </div>
            <div class="col-lg-2">
                <div class="textCenter">
                    <a class="waves-effect waves-light btn resetButton" (click)="reset(true)">
                        Reset
                    </a>
                </div>
            </div>
        </div>
        <div class="row cart-section">
            <div class="col-lg-4">
                <div class="fileUploadTitle">
                    <span>(Step 1) Upload Excel File</span>
                </div>
                <div [style.width.%]="100">
                    <mat-toolbar class="matBG">
                        <input type="text" [hidden]="true">
                        <mat-label [attr.title]="fileTitle" class="file-names">{{selectedExcelFile}}</mat-label>
                        <button class="Mat_btn_Custom_Width" type="button" mat-flat-button color="primary"
                            (click)="invFileUpload.click()" [disabled]="!selectedDocumentType">
                            Choose file
                        </button>
                    </mat-toolbar>
                    <input [attr.type]="fileControlType" #invFileUpload (change)="onSelectExcelFile($event)" hidden />
                </div>
            </div>
            <div class="col-lg-3">
                <div class="fileUploadTitle">
                    <span>(Step 2) Upload Invoice File</span>

                </div>
                <div [style.width.%]="100">
                    <mat-toolbar class="matBG" [ngClass]="invoiceFileType!=''?'mb-20':''">
                        <input type="text" [hidden]="true">
                        <mat-label [attr.title]="fileTitle" class="file-names">{{selectedInvoiceFiles}}</mat-label>
                        <button class="Mat_btn_Custom_Width" type="button" mat-flat-button color="primary"
                            (click)="invFileUpload1.click()" [disabled]="selectedExcelFile==browseMessage">
                            Choose file
                        </button>
                    </mat-toolbar>
                    <input [attr.type]="fileControlType" multiple="multiple" #invFileUpload1
                        (change)="onSelectInvoiceFile($event)" hidden />
                    <span *ngIf="invoiceFileType!=''" class="fileTypeLable"> (Type: {{invoiceFileType}}, Max Size:
                        {{invoiceFileSize}}MB)</span>
                </div>
            </div>
            <div class="col-lg-3">
                <div class="fileUploadTitle">
                    <span>(Step 3) Upload Supporting File</span>
                </div>
                <div [style.width.%]="100">
                    <mat-toolbar class="matBG" [ngClass]="supportingFileType!=''?'mb-20':''">
                        <input type="text" [hidden]="true">
                        <mat-label [attr.title]="fileTitle" class="file-names">{{selectedSupportingFiles}}</mat-label>
                        <button class="Mat_btn_Custom_Width" type="button" mat-flat-button color="primary"
                            (click)="invFileUpload2.click()" [disabled]="selectedInvoiceFiles==browseMessage">
                            Choose file
                        </button>
                    </mat-toolbar>
                    <input [attr.type]="fileControlType" multiple="multiple" #invFileUpload2
                        (change)="onSelectSupportingFile($event)" hidden />
                    <span *ngIf="supportingFileType!=''" class="fileTypeLable"> (Type: {{supportingFileType}}, Max
                        Size: {{supportingFileSize}}MB)</span>

                </div>
            </div>
            <div class="col-lg-2">
                <div class="textCenter">
                    <button class="waves-effect waves-light btn smallButton" (click)="uploadBulkInvoice()"
                        [disabled]="selectedExcelFile==browseMessage">
                        Submit
                    </button>
                </div>
            </div>
        </div>

        <div class="row cart-section">
            <mat-tab-group animationDuration="0ms" [selectedIndex]="selectedTab">
                <mat-tab label="Invoice Details">
                    <div class="dashboard-tabs" id="invoice-table" *ngIf="lstDisplayField.length>0">
                        <div class="grpah-grid-table-responsive">
                            <table class="grpah-grid-table responsive-table">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th style="color: rgb(139, 139, 139);" *ngFor="let col of lstDisplayField"
                                            [ngClass]="col.fieldName=='Status'?'center-align':''">
                                            {{col.fieldName}}
                                        </th>
                                        <th style="color: rgb(139, 139, 139);" *ngIf="workItemFieldChildList.length>0">
                                            Line Items</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let data of lstDisplayData">
                                        <td class="highlight">
                                            <div>
                                                <img *ngIf="data['Message']==''" src="../../../assets/img/right.png"
                                                    alt="Right Icon">
                                                <img *ngIf="data['Message']!=''" src="../../../assets/img/wrong.png"
                                                    alt="Wrong Icon">
                                            </div>
                                        </td>
                                        <td *ngFor="let col of lstDisplayField"
                                            [ngStyle]='getStyle(col.fieldName,data[col.fieldName])'>
                                            <span *ngIf="col.fieldName!='Status'">{{data[col.fieldName]}}</span>
                                            <span *ngIf="col.fieldName=='Status'" class="grpah-grid-table-status-btn"
                                                [ngClass]="getStatusClass(data[col.fieldName])">{{data[col.fieldName]}}</span>

                                        </td>
                                        <td *ngIf="workItemFieldChildList.length>0 "><a
                                                (click)="lineItemList=data['lstchild'];showModal(lineItemModal,'lg')"
                                                *ngIf=" data['lstchild']!=null">view</a></td>
                                        <td class="highlight right-align-high-light">
                                            <div></div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Upload History">
                    <div class="dashboard-tabs" id="invoice-History-table">
                        <div *ngIf="selectedDocumentType==null" class="fontbold">
                            Please select Work Item Type.
                        </div>
                        <div *ngIf="lstHistoryData.length>0" class="grid">
                            <app-basic-gridview [lstData]="lstHistoryData" [gridTitle]="' '" [showRefreshButton]='true'
                                (RefreshEvent)="onRefreshClick()" (cellClickEvent)="cellClick($event)"
                                [hyperlinkCols]="lstHistoyLinkColumn" [columnsToHide]="lstHistoryColumnToHide">
                            </app-basic-gridview>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>

<ng-template #HistoryPopup let-modal>
    <div class="modal-content">
        <div class="modal-header model_center_header">
            <h5 class="modal-title">Bulk Upload File Data</h5>
        </div>
        <div class="modal-body custom_modal_body">
            <div class="model_content">
                <app-basic-gridview [lstData]="lstHistoyFileData" [gridTitle]="' '" [showRefreshButton]='false'
                    [showSearchOption]="false" [showExcelDownloadOption]='false' [recordsPerPage]='10'>
                </app-basic-gridview>
            </div>
        </div>
        <div class="modal-footer model_center_btn_part textCenter">
            <button type="button" class="btn smallButton" (click)="downloadData()">
                Download
            </button>
            <button type="button" class="btn resetButton" (click)="onCloseButtionClick()">
                Close
            </button>
        </div>
    </div>
</ng-template>

<ng-template #lineItemModal let-modal>
    <div class="modal-content">
        <div class="modal-header model_center_header">
            <h5 class="modal-title">Line Items</h5>
            <button type="button" class="close model_close_btn" (click)="modalReference.close()">
                <span aria-hidden="true" class="model_close_btn">×</span>
            </button>
        </div>
        <div class="modal-body custom_modal_body">
            <div class="model_content">

                <div class="grpah-grid-table-responsive" *ngIf="lstChildDisplayField.length>0">
                    <table class="grpah-grid-table responsive-table">
                        <thead>
                            <tr>
                                <th></th>
                                <th style="color: rgb(139, 139, 139);" *ngFor="let col of lstChildDisplayField"
                                    [ngClass]="col.fieldName=='Status'?'center-align':''">
                                    {{col.fieldName}}
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of lineItemList">
                                <td class="highlight">
                                    <div>
                                        <img *ngIf="data['Message']==''" src="../../../assets/img/right.png"
                                            alt="Right Icon">
                                        <img *ngIf="data['Message']!=''" src="../../../assets/img/wrong.png"
                                            alt="Wrong Icon">
                                    </div>
                                </td>
                                <td *ngFor="let col of lstChildDisplayField"
                                    [ngStyle]='getStyle(col.fieldName,data[col.fieldName])'>
                                    <span *ngIf="col.fieldName!='Status'">{{data[col.fieldName]}}</span>
                                    <span *ngIf="col.fieldName=='Status'" class="grpah-grid-table-status-btn"
                                        [ngClass]="getStatusClass(data[col.fieldName])">{{data[col.fieldName]}}</span>

                                </td>
                                <td class="highlight right-align-high-light">
                                    <div></div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>


            </div>
        </div>
    </div>
</ng-template>